import { FormControl, FormHelperText, FormLabel, Textarea } from "@chakra-ui/react";
import { MAX_NOTES } from "./placingUtils";

/** A plain-text notes box (line breaks kept), capped at the API's 20,000 characters. */
const NotesField = ({ label = "Notes", value, onChange, rows = 3, placeholder, isRequired, maxLength = MAX_NOTES, ...props }) => (
  <FormControl isRequired={isRequired} {...props}>
    {label && <FormLabel fontSize="xs">{label}</FormLabel>}
    <Textarea
      size="sm"
      rows={rows}
      value={value}
      maxLength={maxLength}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
    />
    <FormHelperText fontSize="xs" textAlign="right">
      {value.length.toLocaleString()} / {maxLength.toLocaleString()}
    </FormHelperText>
  </FormControl>
);

export default NotesField;
